import {
    Section,
    BottomRightDiv,
    ImageWrapper,
    Image,
    BgLine,
    BgFullGreyLine
} from './style'
import React  from 'react';

const Head = ({ 
    imagePath,
    caption,
    addFullGrey = true
 }) => {
    return (
        <Section>
            <ImageWrapper >
                <Image 
                    src={imagePath} 
                    alt="" 
                />
            </ImageWrapper>
            {caption &&
                <BottomRightDiv addFullGrey={addFullGrey}>
                    {caption}
                </BottomRightDiv>
            }
            {addFullGrey ? <BgFullGreyLine /> : <BgLine />}
        </Section>
    )
}

export default Head;